import { Wallet, X } from '@phosphor-icons/react';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@shared/ui/Button';
import styles from './InsufficientBalanceSheet.module.css';

export function InsufficientBalanceSheet({
  open,
  onClose,
  source = 'purchase',
}: {
  open: boolean;
  onClose: () => void;
  source?: string;
}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open ? (
        <motion.div
          className={styles.backdrop}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.16 }}
          onClick={onClose}
        >
          <motion.section
            className={styles.sheet}
            role="dialog"
            aria-modal="true"
            aria-labelledby="insufficient-balance-title"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', stiffness: 320, damping: 34 }}
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className={styles.close}
              aria-label="Cancel"
              onClick={onClose}
            >
              <X size={19} weight="bold" />
            </button>

            <span className={styles.icon} aria-hidden="true">
              <Wallet size={28} weight="duotone" />
            </span>
            <h2 id="insufficient-balance-title" className={styles.title}>
              Wallet has insufficient balance
            </h2>
            <p className={styles.body}>
              Deposit money into your wallet, then come back to complete your purchase.
            </p>
            <Button
              fullWidth
              onClick={() => {
                onClose();
                navigate(`/wallet?source=${encodeURIComponent(source)}`);
              }}
            >
              Deposit
            </Button>
          </motion.section>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
